import {
    array,
    bool,
    func,
    instanceOf,
    number,
    object,
    oneOfType,
    string,
} from "prop-types";

export const recordSourceTreeGridShape = {
    children: oneOfType([
        array,
        instanceOf(Backbone.Collection) // todo: remove
    ]),
    label: string.isRequired,
    model: object,
    parentType: string,
    shortname: string.isRequired,
    type: string,
    // these are not ubiquitous...
    collapsedAll: bool,
    expandedAll: bool,
    onCollapseAll: func,
    onExpandAll: func,
};

export const recordSourceTreeItemShape = {
    active: bool.isRequired,
    toggleActive: func,
    depth: number.isRequired,
    isMagicRoot: bool,
    recordSourceRecordType: string, // is this needed at all?
    ...recordSourceTreeGridShape,
};



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourcetreegrid/types.js